/* fw-reveal.js — одноразовое появление элементов при попадании в экран.
   Подключается с defer из snippets/fw-head.liquid, то есть один раз на страницу.

   ЗАЧЕМ ОТДЕЛЬНЫМ ФАЙЛОМ
   Анимации нужны сразу нескольким секциям About (полосы графиков, линии
   прогресса в правилах и шагах, линия цепочки, сегменты под цифрой). Если
   каждая секция заведёт свой IntersectionObserver, на странице окажется пять
   наблюдателей и пять копий одного кода. Здесь один наблюдатель на всё.

   КАК ПОЛЬЗОВАТЬСЯ
   Повесить на контейнер data-fw-reveal. При попадании в экран на него ставится
   класс is-in — один раз, обратно не снимается. Вся анимация живёт в CSS секции
   и висит на .is-in; JS не трогает стили, чтобы секция могла менять оформление
   без правок скрипта.

   ПОРОГ 0.2, А НЕ 0
   Полосы графиков высотой 8-10 px при пороге 0 стартуют, когда в кадр попал
   один пиксель контейнера, и анимация проходит за краем экрана. 20 % высоты —
   момент, когда блок уже читается.

   ДОСТУПНОСТЬ
   При prefers-reduced-motion: reduce класс ставится сразу всем и наблюдатель не
   создаётся вовсе. То же самое в браузере без IntersectionObserver. Итоговое
   состояние обязано быть полным: CSS должен рисовать конечный вид по .is-in,
   а не полагаться на переходы. */
(function () {
  'use strict';

  /* Второй экземпляр (скрипт вставлен дважды, например редактором темы)
     завёл бы второго наблюдателя и вторые слушатели. */
  if (window.FWReveal) return;

  var SELECTOR = '[data-fw-reveal]';
  var DONE = 'is-in';

  function markAll(scope) {
    var nodes = (scope || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add(DONE);
  }

  function calm() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  var observer = null;

  function observe(scope) {
    var host = scope || document;
    if (calm() || !('IntersectionObserver' in window)) {
      markAll(host);
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          entries[i].target.classList.add(DONE);
          observer.unobserve(entries[i].target);
        }
      }, { threshold: 0.2 });
    }
    var nodes = host.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].classList.contains(DONE)) observer.observe(nodes[i]);
    }
  }

  function boot() { observe(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Редактор темы перерисовывает секцию целиком — новые узлы надо подхватить */
  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });

  window.FWReveal = { scan: observe };
})();
